import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import questions from './modules/questions'
import getters from './getters'
import experiment from './modules/experiment'
import studentAnalysis from './modules/studentAnalysis'
import teaching from './modules/teaching'
import tree from './modules/tree'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV === 'development'
const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    experiment,
    tree,
    questions,
    studentAnalysis,
    teaching
  },
  getters,
  plugins: debug ? [createLogger()] : []
})
export default store
